var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpFilter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 17.5V15",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 17.5V12.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 5V2.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 7.5V2.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 15C5.05742 15 4.66913 15 4.36284 14.8732C3.95447 14.704 3.63001 14.3795 3.46085 13.9712C3.33398 13.6648 3.33398 13.2766 3.33398 12.5C3.33398 11.7234 3.33398 11.3352 3.46085 11.0288C3.63001 10.6205 3.95447 10.296 4.36284 10.1268C4.66913 10 5.05742 10 5.83398 10C6.61055 10 6.99883 10 7.30513 10.1268C7.7135 10.296 8.03796 10.6205 8.20712 11.0288C8.33398 11.3352 8.33398 11.7234 8.33398 12.5C8.33398 13.2766 8.33398 13.6648 8.20712 13.9712C8.03796 14.3795 7.7135 14.704 7.30513 14.8732C6.99883 15 6.61055 15 5.83398 15Z",
    stroke: "#2C3A4B",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 10C13.3894 10 13.0012 10 12.6948 9.87317C12.2865 9.704 11.962 9.3795 11.7928 8.97117C11.666 8.66483 11.666 8.27657 11.666 7.5C11.666 6.72343 11.666 6.33515 11.7928 6.02886C11.962 5.62048 12.2865 5.29602 12.6948 5.12687C13.0012 5 13.3894 5 14.166 5C14.9426 5 15.3308 5 15.6372 5.12687C16.0455 5.29602 16.37 5.62048 16.5392 6.02886C16.666 6.33515 16.666 6.72343 16.666 7.5C16.666 8.27657 16.666 8.66483 16.5392 8.97117C16.37 9.3795 16.0455 9.704 15.6372 9.87317C15.3308 10 14.9426 10 14.166 10Z",
    stroke: "#2C3A4B",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFilter2);
export default __webpack_public_path__ + "static/media/help-filter-2.6a2cdb16ae83aaca667116defe34a1d0.svg";
export { ForwardRef as ReactComponent };